import { ReactNode } from "react";
import { paths } from "src/paths";
import {
  HpPopover,
  MorePopover,
  NormalPopover,
  PricingPopover,
  ResourcesPopover,
} from "./pages-popover";

export interface Item {
  children?: {
    subheader?: string;
    items: {
      external?: boolean;
      path: string;
      title: string;
    }[];
  }[];
  disabled?: boolean;
  external?: boolean;
  path?: string;
  popover?: ReactNode;
  title: string;
}

export const itemsMobNav: Item[] = [
  {
    title: "Home",
    path: paths.index,
    external: false,
  },
  {
    title: "Services and pricing",
    children: [
      {
        items: [
          {
            title: "Nightscout",
            path: paths.nightscout,
          },
          {
            title: "Coaching",
            path: paths.medicalCoaching,
          },
        ],
      },
      {
        subheader: "Prescriptions",
        items: [
          {
            title: "Lyumjev",
            path: paths.lyumjev,
          },
        ],
      },
    ],
  },
  {
    title: "About Us",
    path: paths.aboutus,
    external: false,
  },
  {
    title: "Resources",
    children: [
      {
        items: [
          {
            title: "Blog",
            path: paths.blog.index,
          },
          {
            title: "Apps",
            path: paths.diabetesmanagementapps,
          },
          {
            title: "Basal Testing Calculator",
            path: paths.basalTestingCalculator,
          },
        ],
      },
      {
        subheader: "Research",
        items: [
          {
            title: "Scientific Publications",
            path: paths.publications,
          },
          {
            title: "Community Research",
            path: paths.communityResearch,
          },
          {
            title: "Loop decision guide",
            path: paths.loopDecisionGuide,
          },
        ],
      },
      {
        items: [
          {
            title: "iAPS",
            path: "https://www.diabetotech.com/i-aps?_gl=1*1072e00*_up*MQ..*_ga*MTMwMzU5NTY0Ny4xNzY3NTEyNjIz*_ga_CQY7RM61QB*czE3Njc1MTI2NDAkbzEkZzAkdDE3Njc1MTI2NDAkajYwJGwwJGgw",
            external: true,
          },
          {
            title: "Loop",
            path: "https://www.diabetotech.com/diy-loop?_gl=1*1072e00*_up*MQ..*_ga*MTMwMzU5NTY0Ny4xNzY3NTEyNjIz*_ga_CQY7RM61QB*czE3Njc1MTI2NDAkbzEkZzAkdDE3Njc1MTI2NDAkajYwJGwwJGgw",
            external: true,
          },
          {
            title: "AndroidAPS",
            path: "https://www.diabetotech.com/android-aps?_gl=1*5rozwu*_up*MQ..*_ga*MTMwMzU5NTY0Ny4xNzY3NTEyNjIz*_ga_CQY7RM61QB*czE3Njc1MTI2NDAkbzEkZzAkdDE3Njc1MTI2NDAkajYwJGwwJGgw",
            external: true,
          },
          {
            title: "About Open-Source Looping",
            path: paths.whatIsopensourcelooping,
          },
        ],
      },
    ],
  },
  {
    title: "More",
    children: [
      {
        items: [
          {
            title: "Our mission",
            path: paths.workmethod,
          },
          {
            title: "Contributions",
            path: paths.contributions,
          },
          {
            title: "Data & Privacy",
            path: paths.dataprivacy,
          },
          {
            title: "Newsletter",
            path: paths.newsletter,
          },
          {
            title: "Contact",
            path: "mailto:info@opensource.clinic",
            external: true,
          },
        ],
      },
    ],
  },
];

export const items: Item[] = [
  {
    title: "Home",
    path: paths.index,
    external: false,
  },
  {
    title: "Services and pricing",
    external: false,
    popover: <PricingPopover />,
  },
  // {
  //   title: "For Healthcare Providers",
  //   external: false,
  //   popover: <HpPopover />,
  // },
  {
    title: "More",
    external: false,
    popover: <MorePopover />,
  },
];

export const itemsTopNav: Item[] = [
  {
    title: "Home",
    path: paths.index,
    external: false,
  },
  {
    title: "Services and pricing",
    external: false,
    popover: <PricingPopover />,
  },
  // {
  //   title: "For Healthcare Providers",
  //   external: false,
  //   popover: <HpPopover />,
  // },
  {
    title: "About Us",
    external: false,
    path: paths.aboutus,
  },
  // {
  //   title: "Blog",
  //   path: paths.blog.index,
  //   external: false,
  // },
  {
    title: "Resources",
    external: false,
    popover: <ResourcesPopover />,
  },
  {
    title: "More",
    external: false,
    popover: <MorePopover />,
  },

  // {
  //   title: "Components",
  //   path: paths.components.index,
  // },
  // {
  //   title: "Pages",
  //   children: [
  //     {
  //       subheader: "Dashboard",
  //       items: [
  //         {
  //           title: "Overview",
  //           path: paths.dashboard.index,
  //         },
  //         {
  //           title: "Customers",
  //           path: paths.dashboard.customers.index,
  //         },
  //         {
  //           title: "Logistics",
  //           path: paths.dashboard.logistics.index,
  //         },
  //         {
  //           title: "File Manager",
  //           path: paths.dashboard.fileManager,
  //         },
  //         {
  //           title: "Academy",
  //           path: paths.dashboard.academy.index,
  //         },
  //       ],
  //     },
  //     {
  //       subheader: "Other",
  //       items: [
  //         {
  //           title: "Blog",
  //           path: paths.dashboard.blog.index,
  //         },
  //         {
  //           title: "Pricing",
  //           path: paths.pricing,
  //         },
  //         {
  //           title: "Contact",
  //           path: paths.workshop,
  //         },
  //         {
  //           title: "Checkout",
  //           path: paths.checkout,
  //         },
  //         {
  //           title: "Error",
  //           path: paths.notFound,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "Docs",
  //   path: paths.docs,
  //   external: true,
  // },
];
